<template>
  <gd-button
    :style="[customCss]"
    v-if="buttonText"
    primary
    size="auto"
    :class="[
      'button-bg-color button-style button-text-color button-border-color',
    ]"
    class="h-10 px-4 bg-blue btn-radius font-semibold text-base hover:bg-blue-dark focus:bg-black"
    @click="buttonCallback(callbackParam)"
    >{{ buttonText }}</gd-button
  >
</template>

<script>
import GdButton from '@groovepages/gd-ui-kit/components/Button';
export default {
  name: 'Button',
  props: {
    buttonText: {
      type: String,
    },
    specialHover: {
      default: false,
    },
    buttonCallback: {
      type: Function,
      required: true,
    },
    callbackParam: {
      required: true,
    },
    getThemeSettings: {},
  },
  components: {
    GdButton,
  },
  computed: {
    customCss() {
      return {
        '--template-button-color': this.themeSettings.bg_color,
        '--template-button-text-color': this.themeSettings.text_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings().button_section;
    },
    buttonRadius() {
      if (this.themeSettings.buttonStyle == 1) {
        return '8px';
      }
      if (this.themeSettings.buttonStyle == 0) {
        return '0px';
      }
      return '6px';
    },
  },
};
</script>
<style scoped>
.button-bg-color {
  background-color: var(--template-button-color);
  opacity: 0.8;
}
.button-bg-color:hover {
  background-color: var(--template-button-color);
  opacity: 1;
}
.button-bg-color:focus {
  background-color: var(--template-button-color);
  opacity: 0.8;
}
.button-text-color {
  color: var(--template-button-text-color);
}
.button-style {
  border-radius: var(--template-button-style);
}
.button-border-color {
  border-width: 1px;
  border-color: var(--template-button-color);
}
</style>
